import { isIOS } from '@react-aria/utils'
import { sortBy } from 'lodash'
import { computed } from 'mobx'
import { observer } from 'mobx-react-lite'

import { CommentableType } from 'components/ActivityEvent/Types'
import { CommentV2 } from 'components/CommentV2/CommentV2'
import { CollabItemType, CommentItem } from 'stores/DocStore.types'
import { useRootStore } from 'stores/RootStore'

import { useCollaborationDialog } from './CollaborationDialogStore'

import { keyboardHeight } from 'utils/virtualKeyboardOverlap'
import { useMobileToolbar } from '../stores/MobileToolbarStore'
import Styles from './CollaborationDialogComments.module.scss'

export const CollaborationDialogComments = observer(function CollaborationDialogComments() {
  const rootStore = useRootStore()
  const collaborationDialogStore = useCollaborationDialog()
  const mobileToolbarStore = useMobileToolbar()
  const showNewComment = collaborationDialogStore.newComment

  /* Navigation Header: Height + Vertical margin + Border */
  const headerSize = 32 + 16 + 1
  /* NewComment: Height + Vertical margin + Border */
  const newCommentSize = 67 + 20 + 1
  const compoundingSize = headerSize + (showNewComment ? newCommentSize : 0)
  const windowHeight = isIOS() ? window.innerHeight : window.visualViewport?.height ?? window.innerHeight
  const availableHeight = windowHeight - (mobileToolbarStore?.appleBottom ?? keyboardHeight())
  const halfTheFullsize = availableHeight / 2 - compoundingSize
  const fullscreenSize = availableHeight - compoundingSize
  const scrollHeight = collaborationDialogStore.fullScreen ? fullscreenSize : Math.min(fullscreenSize, halfTheFullsize)

  const forcedStyle = { maxHeight: `${scrollHeight}px` }

  const noSelection = computed(() => !rootStore.comments.selected?.id).get()
  const selectedNotInFilter = computed(
    () =>
      !rootStore.docStore?.orderedFilteredCollabItems?.some(
        (e): e is CommentItem =>
          !noSelection && e.type === CollabItemType.Comment && rootStore.comments.selected?.id === e.item.id,
      ),
  ).get()
  const comments: CommentItem[] = computed(
    () =>
      rootStore.docStore?.orderedFilteredCollabItems?.filter(
        (e): e is CommentItem =>
          e.type === CollabItemType.Comment &&
          (collaborationDialogStore.viewAll || selectedNotInFilter || rootStore.comments.selected?.id === e.item.id),
      ) ?? [],
  ).get()

  return (
    <div className={Styles.scroll} style={forcedStyle}>
      {comments.map(({ item }) => (
        <div className={Styles.itemWrapper} key={`comment-${item.id}`}>
          <CommentV2
            items={[
              item,
              ...sortBy(
                // TODO: Fix this the next time the file is edited.
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                rootStore.docStore!.rootStore.comments.getByCommentable(item.id, CommentableType.COMMENT),
                'created_at',
              ),
            ]}
          />
        </div>
      ))}
      {comments.length === 0 && <div className={Styles.noComments}>No comments</div>}
    </div>
  )
})
